import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useContextSystem } from '@wp-g2/context';
import { cx } from '@wp-g2/styles';
import { useMemo } from 'react';
import * as styles from './Scrollable.styles';
export function useScrollable(props) {
  var _useContextSystem = useContextSystem(props, 'Scrollable'),
      className = _useContextSystem.className,
      _useContextSystem$scr = _useContextSystem.scrollDirection,
      scrollDirection = _useContextSystem$scr === void 0 ? 'y' : _useContextSystem$scr,
      _useContextSystem$smo = _useContextSystem.smoothScroll,
      smoothScroll = _useContextSystem$smo === void 0 ? false : _useContextSystem$smo,
      otherProps = _objectWithoutProperties(_useContextSystem, ["className", "scrollDirection", "smoothScroll"]);

  var classes = useMemo(function () {
    return cx(styles.Scrollable, styles.scrollableScrollbar, smoothScroll && styles.smoothScroll, scrollDirection === 'x' && styles.scrollX, scrollDirection === 'y' && styles.scrollY, scrollDirection === 'auto' && styles.scrollAuto, className);
  }, [className, scrollDirection, smoothScroll]);
  return _objectSpread(_objectSpread({}, otherProps), {}, {
    className: classes
  });
}